import { useI18n } from "../context/I18nContext";
import { REVIEWS } from "../lib/reviews";
import { Overline, Reveal } from "./Reveal";

// Tarjeta de valoración real: nombre, texto y plataforma. Sin puntuaciones ni países inventados.
export function TestimonialCard({ rating, name, text, platform }) {
  return (
    <div data-testid="testimonial-card" className="border border-charcoal/15 bg-cream p-7">
      {rating ? (
        <div className="flex gap-1">
          {[...Array(5)].map((_, i) => (
            <span key={i} className={`font-corm text-2xl leading-none ${i < rating ? "text-terra" : "text-charcoal/20"}`}>
              ★
            </span>
          ))}
        </div>
      ) : (
        <span className="font-corm text-4xl leading-none text-terra/60">«</span>
      )}
      <p className="mt-4 font-corm text-[1.15rem] leading-snug text-charcoal/90">«{text}»</p>
      <div className="mt-5 flex items-center justify-between gap-3 border-t border-charcoal/10 pt-4 text-xs text-charcoal/55">
        <span className="font-semibold tracking-wide">{name}</span>
        <span className="uppercase tracking-[0.18em]">{platform}</span>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const { t } = useI18n();

  return (
    <section id="opiniones" data-testid="testimonials-section" className="bg-bone py-24 text-charcoal md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>{t.testimonios.overline}</Overline>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-3xl leading-tight sm:text-4xl lg:text-5xl">
              {t.testimonios.title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 leading-relaxed text-charcoal/65">{t.testimonios.lead}</p>
          </Reveal>
        </div>

        <div data-testid="testimonials-grid" className="mt-14 columns-1 gap-6 md:columns-2 lg:columns-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={0.03 * Math.min(i, 8)} className="mb-6 break-inside-avoid">
              <TestimonialCard name={r.name} text={r.text} platform={r.platform} rating={r.rating} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
